import { getNumberOfFiltersApplied as getNumberOfFiltersAppliedUtility } from '../utils/get-number-of-filters-applied';
import { getFilterByIdAndType } from './get-filter-by-id-and-type';
export const getNumberOfFiltersApplied = (props) => {
    const { id, type, keys } = props;
    const filter = getFilterByIdAndType(id, type);
    if (!filter) {
        return 0;
    }
    return getNumberOfFiltersAppliedUtility(filter, keys);
};
//# sourceMappingURL=get-number-of-filters-applied.js.map